//@ts-nocheck
import { TimeIcon } from "@chakra-ui/icons";
import { Box, Flex, HStack } from "@chakra-ui/react";
import React from "react";

const timerHelper = (function () {
  const renderCountdownTimer = (duration) => toTimer(duration);

  const toTimer = (time) => {
    const secs = Math.floor((time / 1000) % 60),
      mins = Math.floor((time / 1000 / 60) % 60);

    const readableTimer = [
      pad(mins.toString(), 2),
      pad(secs.toString(), 2),
    ].join(":");

    return readableTimer;
  };

  const pad = (numberString, size) => {
    while (numberString.length < size) numberString = `0${numberString}`;
    return numberString;
  };

  return {
    renderCountdownTimer,
  };
})();

export function Timer({ duration }) {
  let warning = duration >= 60000 && duration < 300000 && "orange.500";
  let danger = duration < 60000 && "crimson.500";
  return (
    <Flex flexDirection="column" className="TestInfoWrap">
      <HStack fontWeight="medium" color={warning || danger} spacing={1}>
        <TimeIcon />
        <Box textAlign="right">
          {timerHelper.renderCountdownTimer(duration)}
        </Box>
      </HStack>
    </Flex>
  );
}

export default Timer;
